// src/pages/Room.js
import React, { useRef, useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { ZegoUIKitPrebuilt } from "@zegocloud/zego-uikit-prebuilt";

function Room() {
	const { roomId } = useParams();
	const location = useLocation();
	const navigate = useNavigate();
	const containerRef = useRef(null);
	const [ready, setReady] = useState(false);

	useEffect(() => {
		// Ensure component is mounted before rendering Zego
		setReady(true);
	}, []);

	useEffect(() => {
		if (!ready || !containerRef.current) return;

		const query = new URLSearchParams(location.search);
		const type = query.get("type");

		const kitToken = ZegoUIKitPrebuilt.generateKitTokenForTest(
			579681112,
			"6db7d1e5304431bcc6cd9362c67d6c07",
			roomId,
			Date.now().toString(), // Random user ID — replace with auth if needed
			"User", // Replace with logged-in user’s name
		);

		const zp = ZegoUIKitPrebuilt.create(kitToken);

		zp.joinRoom({
			container: containerRef.current,
			scenario: {
				mode: ZegoUIKitPrebuilt.OneONoneCall,
			},
			showPreJoinView: false, // ✅ no "Join Room" screen
			showRoomDetailsButton: false, // ✅ hide room info
			showScreenSharingButton: false, // ✅ hide screen share
			showMyCameraToggleButton: false, // ✅ hide camera toggle
			showAudioVideoSettingsButton: false, // ✅ hide A/V settings
			showLayoutButton: false, // ✅ hide layout options
			showTextChat: false, // ✅ hide text chat
			onLeaveRoom: () => {
				setTimeout(() => {
					navigate("/my-consultations");
				}, 300);
			},
		});

		return () => {
			try {
				zp?.destroy?.(); // Safely destroy on unmount
			} catch (err) {
				console.warn("Error during Zego cleanup:", err);
			}
		};
	}, [ready, containerRef, roomId, location, navigate]);

	return (
		<div
			ref={containerRef}
			style={{ width: "100vw", height: "100vh", backgroundColor: "#000" }}
		/>
	);
}

export default Room;
